import React from 'react';
import { usePearlModal } from 'framework';
import EmailVerificationPanel from './EmailVerificationPanel';
import { VerifyEmailModalShell } from './EmailVerificationPanel.styled';

const VerificationModalContent = ({ onVerify, email }) => {
    const { closeModal } = usePearlModal();

    return (
        <VerifyEmailModalShell data-testid="modal-container">
            <button
                type="button"
                onClick={closeModal}
                style={{
                    position: 'absolute',
                    top: '20px',
                    right: '20px',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '24px',
                    height: '24px',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.color = '#234a4c')}
                onMouseLeave={(e) => (e.currentTarget.style.color = '#315454')}
            >
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{ color: '#315454' }}
                >
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
            </button>
            <EmailVerificationPanel
                email={email}
                onVerified={() => {
                    onVerify?.();
                    closeModal();
                }}
            />
        </VerifyEmailModalShell>
    );
};

export default VerificationModalContent;
